<div class="search-container">
  <input
    type="text"
    class="search-input"
    #searchInput
    [(ngModel)]="searchText"
    debounceKeyup
    (textChanged)="emitTextChanged()"
    [placeholder]="placeholder"
    [ngClass]="{ 'left-align': iconDirection !== 'right', 'right-align': iconDirection === 'right' }"
    id="search-input"
    aria-label="Search bar"
  />
  <button
    class="search-icon"
    (click)="searchInput.focus()"
    mat-icon-button
    [ngClass]="{ 'left-align': iconDirection !== 'right', 'right-align': iconDirection === 'right' }"
    aria-label="Search"
    id="search-button"
  >
    <mat-icon class="md-24">search</mat-icon>
  </button>
</div>
